import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { GeneralService } from 'src/app/services/general/general.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-class',
  templateUrl: './class.component.html',
  styleUrls: ['./class.component.scss'],
})
export class ClassComponent implements OnInit, OnDestroy {
  public loading = true;
  public message = 'loading';
  public interval: any;
  public domain: any;
  public room: any;
  public headerHeight: any = 0;
  public showChat: any = false;
  public chatSelected: any = null;
  public classId: any = null;
  public user: any;
  public userInfo: any;
  constructor(
    public general: GeneralService,
    public route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    try {
      await this.getUserInfo();
      window.dispatchEvent(new CustomEvent('hide:support'));
      this.message = await this.general.getTranslations('loading');
      const params = this.route.snapshot.params;
      switch (params.type) {
        case 'group_class':
          this.classId = params.id;
          await this.getSingleClassData(params.id);
          break;
        case 'weekly_class':
        case 'test_class':
        case 'single_class': {
          this.classId = params.id;
          await this.getSingleClassData(params.id);
          break;
        }
      }
    } catch (error) {
      console.log(error);
      this.general.back();
    }
  }

  
  async ngOnDestroy() {
    window.dispatchEvent(new CustomEvent('show:support'));
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  async getSingleClassData(id: string) {
    const response = await this.general.httpGet(`join-teacher-class/${id}`);
    switch (response.data.action) {
      case 'wait_time': {
        const seconds = response.data.seconds < 5 ? 5 : response.data.seconds;
        await this.initInterval(seconds);
        this.message = await this.general.getTranslations('loading');
        await this.getSingleClassData(id);
        break;
      }
      case 'wait_teacher':
        this.message = await this.general.getTranslations('waiting-teacher');
        await this.general.sleep(1000 * 15);
        await this.getSingleClassData(id);
        break;
      case 'enter':
        if (this.user.rol === 'student') {
          this.chatSelected = response.data.teacher_id;
          await this.general.sleep(1000 * 5);
        } else {
          this.chatSelected = response.data.student_id;
        }

        this.domain = response.data.url.split('/')[0];
        this.room = response.data.url.split('/')[1];
        this.loading = false;
        break;
    }
  }

  async initInterval(time: any) {
    this.interval = setInterval(() => {
      if (time <= 0) {
        clearInterval(this.interval);
        return;
      }
      this.message = new Date(time * 1000).toISOString().substr(11, 8);
      time--;
    }, 1000);
    await this.general.sleep(time * 1000);
  }

  setHeaderHeight($event: any) {
    this.headerHeight = $event;
  }

  async onDismissCall() {
    if (this.user.rol === 'student') {
      this.showRatingClass();
      await this.general.navigate('/student/agenda');
    } else {
      await this.general.navigate('/teacher/agenda');
    }
  }

  async onUpdateTimeClass() {
    try {
      await this.general.httpPost('check-videocall', {
        class_id: this.classId,
      });
    } catch (error) {
      console.log(error);
    }
  }

  showRatingClass() {
    console.log('show Dialog Rating');
  }

  onToggleChat($event: any) {
    this.showChat = $event;
  }
}
